import React from 'react';
import PropTypes from 'prop-types';
import Credits from '../base/Credits';
import IFrame from '../base/IFrame';
import Teasers from '../base/Teasers';
import Flourish from '../base/Flourish';

const ArchieElement = ({ data, relatedLinks }) => {
  const archieObj = JSON.parse(data.archieJson);
  // check for archie key/values like this
  if (archieObj.archieTest) {
    console.log(`archieObj.archieTest key detected: ${archieObj.archieTest}`);
  }
  // case comments
  if (archieObj.comments) {
    const buttonText = archieObj.text ? archieObj.text : 'Comments: Join the discussion';
    return (
      <p className="discussion">
        <a href={archieObj.comments} className="benton-n6">{buttonText}</a>
      </p>
    );
  }
  // case teasers
  if (archieObj.teasers) {
    if (relatedLinks.length > 0) {
      return (<Teasers relatedlinks={relatedLinks} />);
    }
    return (null);
  }
  // case credits
  if (archieObj.credits) {
    return (<Credits data={archieObj} />);
  }
  // case iframe
  if (archieObj.iframe) {
    return (<IFrame data={archieObj} arcId={data._id} />);
  }
  // case flourish
  if (archieObj.flourish) {
    return (<Flourish flourish={archieObj.flourish} />);
  }
  return (
    <div className="archie content">
      <code>
        {JSON.stringify(archieObj)}
      </code>
    </div>
  );
};
ArchieElement.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.oneOf(['custom_embed']),
    subtype: PropTypes.oneOf(['archieml']),
    archieJson: PropTypes.string,
    _id: PropTypes.string,
  }).isRequired,
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      headlines: PropTypes.shape({
        basic: PropTypes.string,
      }),
      promoImage: PropTypes.shape({
        sizes: PropTypes.shape({
          _480: PropTypes.string,
        }),
        srcSet: PropTypes.string,
      }),
      url: PropTypes.string,
    }),
  ),
};

ArchieElement.defaultProps = {
  relatedLinks: null,
};

export default ArchieElement;
